import React, { useState } from "react";
import { useGetProjectsQuery } from "../../features/project/projectsAPI";
import ModalForAddingProject from "../PageComponents/ModalForAddingProject";
import Project from "./Project";

export default function BacklogProjects() {
  const [modal, setModal] = useState(false);
  const status = "Backlog";
  const { data: projects, isLoading } = useGetProjectsQuery(status);
  if (isLoading) return "Loading...";
  return (
    <div className="flex flex-col flex-shrink-0 w-72">
      <div className="flex items-center flex-shrink-0 h-10 px-2">
        <span className="block text-sm font-semibold">Backlog</span>
        <span className="flex items-center justify-center w-5 h-5 ml-2 text-sm font-semibold text-indigo-500 bg-white rounded bg-opacity-30">
          {projects?.length}
        </span>
        <button
          onClick={() => setModal(true)}
          className="flex items-center justify-center w-6 h-6 ml-auto text-indigo-500 rounded hover:bg-indigo-500 hover:text-indigo-100"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
            ></path>
          </svg>
        </button>
      </div>
      <div className="flex flex-col pb-2 overflow-auto">
        {projects?.map((project) => (
          <Project option={true} key={project.id} projectDet={project} />
        ))}
      </div>
      {modal && <ModalForAddingProject setModal={setModal} />}
    </div>
  );
}
